import { Pipe, PipeTransform } from '@angular/core';

/**
 * @FIXME The methods in this pipe should only take in primitive values.
 * @TODO Refactor this pipe to something more simplified.
 * This pipe should simply aid in determining the icon to show for a given type. Not actually check the validity of the filetype.
 */
@Pipe({
    name: 'fileTypeIcon',
    standalone: false
})
export class FileTypeIconPipe implements PipeTransform {
  transform(item: PipeInput): string {
    if (item.error) {
      return 'fa-regular fa-file-exclamation';
    } else if (this.canShowExcelIcon(item)) {
      return 'fa-regular fa-file-excel';
    } else if (this.canShowCsvIcon(item)) {
      return 'fa-regular fa-file-csv';
    } else if (this.canShowPdfIcon(item)) {
      return 'fa-regular fa-file-pdf';
    } else if (this.canShowWordIcon(item)) {
      return 'fa-regular fa-file-word';
    } else if (this.canShowImageIcon(item)) {
      return 'fa-regular fa-file-image';
    }
    return 'fa-regular fa-file-exclamation';
  }

  private canShowExcelIcon(file: PipeInput): boolean {
    return file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
  }

  private canShowCsvIcon(file: PipeInput): boolean {
    return file.name.endsWith('.csv');
  }

  private canShowPdfIcon(file: PipeInput): boolean {
    return file.name.endsWith('.pdf');
  }

  private canShowWordIcon(file: PipeInput): boolean {
    return file.name.endsWith('.doc') || file.name.endsWith('.docx');
  }

  private canShowImageIcon(file: PipeInput): boolean {
    return (
      file.name.endsWith('.png') ||
      file.name.endsWith('.jpg') ||
      file.name.endsWith('.jpeg') ||
      file.name.endsWith('.avif') ||
      file.name.endsWith('.webp') ||
      file.name.endsWith('.gif')
    );
  }
}

export interface FileLikeObject {
  id?: string;
  name: string;
  size: number;
  type: string;
  rawFile: File;
  isLoading: boolean;
  error?: string;
  errors?: Array<string>;
  url?: string;
}

interface PipeInput {
  error?: string;
  name: string;
}
